import React, { useEffect, useState } from 'react';
import './RecentTable.css'
import RTableRow from './RTableRow';
import { supabase } from '../../supabase';

const RecentBookingsTable = (props) => {

    const [bookings, setBookings] = useState([]);

    useEffect(()=>{
            const getBookings = async () => {
                const res = await supabase.from('Bookings').select(`id,total_Price,status,Users:user_ID ( user_Name ),Events:event_ID ( event_Name )`);
                setBookings(res.data);
                console.log(res.data)
            }
    
            getBookings();
        } , [])

    return ( <div className='RecentTable'>
        <p className='RTableName'>
            {props.RTableName}
        </p>

        <div className='RTableRows'>
            {
                bookings.map((item)=>{
                   return <RTableRow key={item.id} RowName={item.Users?.user_Name} RowSub={item.Events?.event_Name} RowInfo={"$"+item.total_Price} RowTag={item.status} TagStyle='Confirmed'/>
                })
            }
        </div>
    </div> );
}
 
export default RecentBookingsTable;
